/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RouteTypeEnum } from './routeTypeEnum';
import { ServerTypeEnum } from './serverTypeEnum';


export interface SmsRouteDto { 
    creatorId?: string;
    smsRouteId?: string;
    isOwnedByCoure: boolean;
    isTopLevel: boolean;
    groupIdentifier?: string;
    operatorCode?: string;
    accessType?: string;
    routeCanBeUsedForMultipleOperators: boolean;
    publicName?: string;
    smsRouteName?: string;
    description?: string;
    serverType: ServerTypeEnum;
    serverTypeEnumName?: string;
    active: boolean;
    dateCreated: Date;
    networkCode?: string;
    routeTypeName?: string;
    routeType: RouteTypeEnum;
    country?: string;
    countryCode?: string;
    mnc?: string;
    mcc?: string;
}
